import axios from "../../adminCompenents/config/axiosConfig";

export default class PromoService {
  // 🔹 Récupérer toutes les promos
  getAllPromos = async () => {
    try {
      const response = await axios.get("/promos");
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération des codes promo : " + error.message
      );
    }
  };

  // 🔹 Créer un code promo
  createPromo = async (data) => {
    try {
      const response = await axios.post("/promos", data);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création du code promo : " + error.message
      );
    }
  };

  // 🔹 Modifier un code promo
  updatePromo = async (id, data) => {
    try {
      const response = await axios.put(`/promos/${id}`, data);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la modification du code promo : " + error.message
      );
    }
  };

  // 🔹 Activer / désactiver un code promo
  togglePromoStatus = async (id) => {
    try {
      const response = await axios.patch(`/promos/${id}/toggle-status`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors du changement de status du code promo : " + error.message
      );
    }
  };

  // 🔹 Récupérer un code promo par ID
  getPromoById = async (id) => {
    try {
      const response = await axios.get(`/promos/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération du code promo : " + error.message
      );
    }
  };

  // 🔹 Supprimer un code promo
  deletePromo = async (id) => {
    try {
      const response = await axios.delete(`/promos/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la suppression du code promo : " + error.message
      );
    }
  };
}
